// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.v-bottom-sheet > .v-bottom-sheet__content.v-overlay__content > .v-card[data-v-693422a2],\n  .v-bottom-sheet > .v-bottom-sheet__content.v-overlay__content > .v-sheet[data-v-693422a2] {\n    border-radius: 24px 24px 0px 0px !important;\n    padding-top: 0;\n    padding: 5px 30px 30px 30px;\n}\n.cursor[data-v-693422a2] {\n    cursor: pointer;\n}\n  ", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
